import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Segment, Menu, Button } from 'semantic-ui-react';
import {
  closeBusinessDetails,
  setBusinessMenuItem,
} from 'state/business/actions';
import OutletSection from './OutletSection';
import EmployeeSection from './EmployeeSection';
import BusinessSection from './BusinessSection';
import LinkingSection from './LinkingSection';

const BusinessDetails = props => {
  const { dispatch, menuItem } = props;

  const handleOnDoneButtonClick = () => {
    dispatch(closeBusinessDetails());
  };

  const handleItemClick = (e, { name }) => {
    dispatch(setBusinessMenuItem(name));
  };

  return (
    <>
      <Segment basic style={{ margin: '0px' }}>
        <Menu pointing secondary>
          <Menu.Item
            name="business"
            active={menuItem === 'business'}
            onClick={handleItemClick}
          />
          <Menu.Item
            name="outlets"
            active={menuItem === 'outlets'}
            onClick={handleItemClick}
          />
          <Menu.Item
            name="employees"
            active={menuItem === 'employees'}
            onClick={handleItemClick}
          />
          <Menu.Item
            name="linking"
            active={menuItem === 'linking'}
            onClick={handleItemClick}
          />
        </Menu>
      </Segment>
      {menuItem === 'business' ? <BusinessSection /> : <></>}
      {menuItem === 'employees' ? <EmployeeSection /> : <></>}
      {menuItem === 'linking' ? <LinkingSection /> : <></>}
      {menuItem === 'outlets' ? <OutletSection /> : <></>}
      <Segment secondary padded clearing attached="bottom">
        <Button
          type="button"
          floated="right"
          color="blue"
          onClick={handleOnDoneButtonClick}
        >
          Done
        </Button>
      </Segment>
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  menuItem: business.menuItem,
});

BusinessDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
  menuItem: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(BusinessDetails);
